const TOKEN_ID_KEY = 'tokenId';

const noOpStorage = {
  getStoredTokenData: () => null,
  storeTokenData: () => {},
  removeTokenId: () => {},
};

const createRealStorage = storage => {
  const getStoredTokenData = () => {
    const encodedData = storage.getItem(TOKEN_ID_KEY);
    if (!encodedData) {
      return null;
    }
    try {
      const jsonString = atob(encodedData);
      return JSON.parse(jsonString);
    } catch (error) {
      console.error('Error parsing token data:', error);
      return null;
    }
  };

  const storeTokenData = dataToStore => {
    const jsonString = JSON.stringify(dataToStore);
    const encodedData = btoa(jsonString);
    storage.setItem(TOKEN_ID_KEY, encodedData);
  };

  const getEmailOnce = () => {
    const tokenData = getStoredTokenData();
    if (tokenData?.email) {
      const { email } = tokenData;
      delete tokenData.email;
      storeTokenData(tokenData);
      return email;
    }
    return '';
  };

  const removeTokenId = () => {
    storage.removeItem(TOKEN_ID_KEY);
  };

  return {
    getStoredTokenData,
    getEmailOnce,
    storeTokenData,
    removeTokenId,
  };
};

const getStorageApi = () => {
  try {
    const storage = window.sessionStorage;
    const testKey = '__storage_test__';
    storage.setItem(testKey, testKey);
    storage.removeItem(testKey);
    return createRealStorage(storage);
  } catch (e) {
    console.warn('Session storage is not available. Apple Pay token management will be disabled.');
    return noOpStorage;
  }
};

const tokenStorageApi = getStorageApi();

export const getStoredTokenData = tokenStorageApi.getStoredTokenData;
export const storeTokenData = tokenStorageApi.storeTokenData;
export const removeTokenId = tokenStorageApi.removeTokenId;
export const getEmailOnce = tokenStorageApi.getEmailOnce;
